module.exports = __webpack_public_path__ + "img/digital-day-use.ce747275.png";